import '../styles/home.css';
import { site } from '../content/site';
import { credentials, credentialsIntro, homeBlurbs } from '../content/copy';

export function mount(container: HTMLElement): () => void {
  const section = document.createElement('section');
  section.className = 'page page-home';

  const blurbs = homeBlurbs.map(b => `<p>${b}</p>`).join('');

  const rows = credentials
    .map(
      c => `<li>
        <span class="cred-venue">${c.venue}</span>
        <span class="cred-location">${c.location}</span>
        <span class="cred-work">${c.work}</span>
      </li>`,
    )
    .join('');

  section.innerHTML = `
    <div class="hero content-panel">
      <h1>${site.title}</h1>
      <p class="tagline">${site.tagline}</p>
      ${blurbs ? `<div class="home-blurbs">${blurbs}</div>` : ''}
      ${
        rows
          ? `<p class="credentials-intro">${credentialsIntro}</p>
      <ul class="home-credentials" role="list">${rows}</ul>`
          : ''
      }
      <a href="#/gallery" class="cta-btn">View work</a>
    </div>
  `;
  container.append(section);
  return () => section.remove();
}
